export const toQueryString = (obj: any): string => {
  const urlParams = new URLSearchParams();
  Object.entries(obj).forEach(
    ([key, value]) => value && urlParams.set(key, `${value}`)
  );

  return `${urlParams}`;
};

export const toQueryParamsObject = (str: string): URLSearchParams => {
  return new URLSearchParams(str);
};
